import type { TableData } from '../../../design-system';
import type { Column } from '../../dataTable/columns';

export function accessibilityLabel(columnDef: Column<TableData>): string {
  const { title } = columnDef;
  return typeof title === 'string' ? `filter data by ${title}` : 'filter data';
}
